<template>
  <div class="d-flex flex-column py-5">
    <!-- <div class="d-block text-h6 black--text font-weight-bold mt-4">Lokasi Tokomu</div> -->
    
    <v-card flat outlined :loading="loading" class="mt-3">
      <v-card-text v-if="!loading">
        <v-form ref="formAddAddress" role="form">
          <v-card class="mb-5">
            <v-card-title class="primary--text">Data Toko</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row align="center">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Nama Toko</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-text-field v-model="params.store_name" :rules="rules.nama" @focus="() => responseError.store_name=''" :error-messages="responseError.store_name"  dense validate-on-blur single-line outlined class="rounded-lg text-body-1" placeholder="Isi Nama Toko" hide-details="auto"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 text-left font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Email</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-text-field v-model="params.store_email" single-line outlined class="rounded-lg text-body-1" dense hide-details="auto" @focus="() => responseError.store_email=''" :error-messages="responseError.store_email" :rules="rules.email" validate-on-blur></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Nomor Telepon</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-text-field v-model="params.store_phone" :rules="rules.mobilephone" @keypress="onlyNumber" single-line outlined class="rounded-lg text-body-1" dense placeholder="Nomor telepon toko Anda" hide-details="auto"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          
          <v-card class="mb-5">
            <v-card-title class="primary--text">Alamat Toko</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row align="center">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Provinsi</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-autocomplete v-model="params.store_province_id" :preset-val="params.store_province_id" :rules="rules.province" :items="provinces" item-text="province_name" item-value="province_id" single-line outlined class="rounded-lg text-body-1" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeProvince(params.store_province_id)">
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-if="params.store_province_id">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Kota/Kabupaten</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-autocomplete v-model="params.store_city_id" :rules="rules.city" :items="cities" item-text="city_name" item-value="city_id" single-line outlined class="rounded-lg text-body-1" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeCity(params.store_city_id)">
                    <template v-slot:item = {item}>
                      {{ item.city_name }}
                    </template>
                    <template v-slot:selection = {item}>
                      {{ item.city_name }}
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-if="params.store_city_id" id="city"  align="center">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Kecamatan</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-autocomplete v-model="params.store_district_id" :rules="rules.district" :items="districts" item-text="district_name" item-value="district_id" single-line outlined class="rounded-lg text-body-1" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeDistrict(params.store_district_id)"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-if="params.store_district_id" id="district"  align="center">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Desa</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-autocomplete v-model="params.store_sub_district_id" :rules="rules.subdistrict" :items="subdistricts" item-text="sub_district_name" item-value="sub_district_id" single-line outlined class="rounded-lg text-body-1" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeSubdistrict(params.store_sub_district_id)"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-if="params.store_sub_district_id" align="center">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Alamat Lengkap</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-textarea v-model="params.store_address_detail" :rules="rules.detail" single-line outlined class="rounded-lg text-body-1" placeholder="Isi nama jalan, nomor rumah, nama gedung, dsb" hide-details="auto" no-resize></v-textarea>
                </v-col>
              </v-row>
              <v-row v-if="params.store_sub_district_id" align="center">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Kode Pos</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-text-field v-model="params.store_sub_district_postal_code" @keypress="onlyNumber" disabled single-line outlined class="rounded-lg text-body-1" dense placeholder="Kode Pos" hide-details="auto"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mb-5" v-if="false">
            <v-card-title class="primary--text">Rekening Bank Toko</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row align="center">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Nama Bank</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-autocomplete v-model="params.store_bank_name" :rules="rules.bank" :items="banks" item-text="bank_name" item-value="bank_name" single-line outlined class="rounded-lg text-body-1" dense hide-details="auto" no-data-text="Tidak ada data" @change="changeBank()"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 text-left font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Nama Rekening Bank</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-text-field v-model="params.store_bank_account_name" validate-on-blur single-line outlined class="rounded-lg text-body-1" dense hide-details="auto" @focus="() => responseError.store_bank_account_name = ''" :error-messages="responseError.store_bank_account_name" :rules="rules.bank_account_name"></v-text-field>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 text-left font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Nomor Rekening</div></v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-text-field outlined @keypress="onlyNumber" dense v-model="params.store_bank_account_number" hide-details="auto" @focus="() => responseError.store_bank_account_number=''" :error-messages="responseError.store_bank_account_number" :rules="rules.bank_account_number" validate-on-blur></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <hr class="mt-5">
          <v-row>
            <v-col cols="12" sm="12" class="text-right">
              <v-btn
                color="green"
                :loading="loadingProcess"
                class="my-2 px-5 text-capitalize white--text btn-block-xs font-weight-bold mx-1"
                @click="saveUpdate()"
              >
                Simpan Data Toko
              </v-btn>
              <v-btn depressed large class="text-capitalize font-weight-bold text-body-2 btn-block-xs rounded-lg mx-1" @click="cancelUpdate">Batalkan Update</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-text v-else>
        <div class="pa-4 rounded-lg" style="border: 1px solid #999;">Sedang menampilkan data toko Anda...</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export default {
  name: 'penghasilan-saya',
  data() {
    return {
      loadingProcess: false,
      loading: false,
      params: {
        store_name: '',
        store_email: '',
        store_phone: '',
        store_province_id: '',
        store_city_id: '',
        store_district_id: '',
        store_sub_district_id: '',
        store_sub_district_postal_code: '',
        store_address_detail: '',
        store_bank_name: '',
        store_bank_account_name: '',
        store_bank_account_number: '',
      },
      address: '',
      provinces: [],
			cities: [],
      districts: [],
			subdistricts: [],
      banks: [],
			longitude: '',
      latitude: '',
      rules:{
        name: [
				v => !!v || 'Nama Toko tidak boleh kosong',
				],
				mobilephone: [
				v => !!v || 'Nomor Telepon Toko idak boleh kosong',
				],
				email: [
					v => !!v || 'Email Toko tidak boleh kosong',
					v => !!validateEmail(v) || 'Format Email tidak sesuai',
				],
        province: [
          v => !!v || 'Provinsi tidak boleh kosong',
        ],
        city: [
          v => !!v || 'Kota tidak boleh kosong',
        ],
        district: [
          v => !!v || 'Kecamatan tidak boleh kosong',
        ],
        subdistrict: [
          v => !!v || 'Desa tidak boleh kosong',
        ],
        address: [
          v => !!v || 'Detail alamat tidak boleh kosong',
				],
        zipcode: [
          v => !!v || 'Kode pos alamat tidak boleh kosong',
				],
        bank: [
          v => !!v || 'Nama Bank tidak boleh kosong',
				],
        bank_account_name: [
          v => !!v || 'Nama Rekening tidak boleh kosong',
				],
        bank_account_number: [
          v => !!v || 'Nomor Rekening tidak boleh kosong',
				],
      }
    }
  },

  computed: {
    ...mapState('storeSeller', ['detailStore', 'response', 'responseError']),
  },

  methods: {
    ...mapActions('storeSeller', ['getStoreDetail', 'updateStore']),
    ...mapMutations(['makeAlert']),

    async getBanks() {
			await this.$http
				.get(`bank/get-bank`)
				.then((res) => {
					const data = res.data.data
					this.banks = data.results
				})
				.catch((error) => {
					console.log(error.response.data.message)
				})
		},
    
    async getProvince() {
			await this.$http
				.get(`area/get-province`)
				.then((res) => {
					const data = res.data.data
					this.provinces = data.results
				})
				.catch((error) => {
					console.log(error.response.data.message)
				})
		},

		async getCity(province_id) {
			await this.$http
				.get(`area/get-city?limit=0&province_id=${province_id}`)
				.then((res) => {
					const data = res.data.data
					this.cities = data.results
				})
				.catch((error) => {
					console.log(error.response.data.message)
				})
		},

		async getDistrict(city_id) {
			await this.$http
				.get(`area/get-district?limit=0&city_id=${city_id}`)
				.then((res) => {
					const data = res.data.data
					this.districts = data.results
				})
				.catch((error) => {
					console.log(error.response.data.message)
				})
		},

		async getSubdistrict(district_id) {
			await this.$http
				.get(`area/get-sub-district?limit=0&district_id=${district_id}`)
				.then((res) => {
					const data = res.data.data
					this.subdistricts = data.results
				})
				.catch((error) => {
					console.log(error.response.data.message)
				})
		},

    async loadAddress(province, city, district) {
      await this.$http
				.get(`area/get-city?limit=0&province_id=${province}`)
				.then((res) => {
					const data = res.data.data
					this.cities = data.results

          this.$http
            .get(`area/get-district?limit=0&city_id=${city}`)
            .then((res) => {
              const data = res.data.data
              this.districts = data.results

              this.$http
                .get(`area/get-sub-district?limit=0&district_id=${district}`)
                .then((res) => {
                  const data = res.data.data
                  this.subdistricts = data.results
                })
                .catch((error) => {
                  console.log('load sub district', error.response.data.message)
                })
            })
            .catch((error) => {
              console.log('load district', error.response.data.message)
            })
				})
				.catch((error) => {
					console.log('load city', error.response.data.message)
				})
    },

    async initData() {
      this.loading = await true
      await this.getProvince()
      await this.getBanks()
      await this.getStoreDetail()
      .then(() => {
        this.params = {
          store_name: this.detailStore.store_name,
          store_email: this.detailStore.store_email,
          store_phone: this.detailStore.store_phone,
          store_province_id: encodeURIComponent(this.detailStore.store_province_id),
          store_city_id: encodeURIComponent(this.detailStore.store_city_id),
          store_district_id: encodeURIComponent(this.detailStore.store_district_id),
          store_sub_district_id: encodeURIComponent(this.detailStore.store_sub_district_id),
          store_sub_district_postal_code: this.detailStore.store_sub_district_postal_code,
          store_address_detail: this.detailStore.store_address_detail,
          store_bank_id: this.detailStore.store_bank_id,
          store_bank_name: this.detailStore.store_bank_name,
          store_bank_account_name: this.detailStore.store_bank_account_name,
          store_bank_account_number: this.detailStore.store_bank_account_number,
        }

        if (this.params.store_province_id !== '') {
          this.loadAddress(encodeURIComponent(this.detailStore.store_province_id), encodeURIComponent(this.detailStore.store_city_id), encodeURIComponent(this.detailStore.store_district_id))
        }

        setTimeout(() => {
          this.loading = false
        }, 1000);
      })
      .catch(() => {
        this.loading = false
      })
    },

    async saveUpdate() {
			if(this.$refs.formAddAddress.validate()) {
        this.loadingProcess = await true

        const apiParams = {
          store_name: this.params.store_name,
          store_email: this.params.store_email,
          store_phone: this.params.store_phone,
          store_province_id: decodeURIComponent(this.params.store_province_id),
          store_city_id: decodeURIComponent(this.params.store_city_id),
          store_district_id: decodeURIComponent(this.params.store_district_id),
          store_sub_district_id: decodeURIComponent(this.params.store_sub_district_id),
          store_sub_district_postal_code: this.params.store_sub_district_postal_code,
          store_address_detail: this.params.store_address_detail,
          // store_bank_id: this.params.store_bank_id,
          // store_bank_name: this.params.store_bank_name,
          // store_bank_account_name: this.params.store_bank_account_name,
          // store_bank_account_number: this.params.store_bank_account_number,
        }
        
        this.updateStore(apiParams)
          .then(async() => {
            await this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
            await this.initData()

            this.loading = false
            this.loadingProcess = false
          })
          .catch(() => {
            this.loadingProcess = false
          })
			} else {
        this.loadingProcess = false
      }
    },

    cancelUpdate() {
      location.reload();
    },
    
    changeProvince(id) {
      this.params.store_city_id = ''
      this.params.store_district_id = ''
      this.params.store_sub_district_id = ''
      this.params.store_sub_district_postal_code = ''

			this.getCity(id)
		},
		changeCity(id) {
      // this.params.store_city_id = id
      this.params.store_district_id = ''
      this.params.store_sub_district_id = ''
      this.params.store_sub_district_postal_code = ''

			this.getDistrict(id)
		},
    changeDistrict(id) {
      // this.params.store_district_id = id
      this.params.store_sub_district_id = ''
      this.params.store_sub_district_postal_code = ''
			this.getSubdistrict(id)
		},
		changeSubdistrict(id) {
      if (id && this.subdistricts.length > 0) {
        let zipcode = this.subdistricts.find(x => x.sub_district_id == id)
        if (zipcode) this.params.store_sub_district_postal_code = zipcode.sub_district_postal_code 
        console.log(zipcode)
      }

      // console.log(this.params)
		},
    changeBank() {
			// this.params.store_bank_account_name = ''
			// this.params.store_bank_account_number = ''
		},
  },

  mounted() {
    this.initData()
  },

  created() {
    this.$store.dispatch('setPageTitle', `Ubah Alamat`);
  }
}
</script>